import { IApiError } from '@/models/apiError.model';
import { DatePresetKey } from '@/models/cancelledOrders.model';
import {
  ICityStatisticData,
  ICategoryStatisticItem,
  IDashboardData,
  IBuyersData,
  IAdminMainMetricsData,
  IAdminMainMetricsQuery,
  MainMetricsGroupBy,
} from '@/models/dashboard.model';
import { TDashboardCityStatisticQuery, TDashboardCategoriesStatisticQuery } from '../helpers';
import { DEFAULT_MAIN_METRICS_PRESET } from '../helpers/datePresets';

export const DASHBOARD_SLICE_NAME = 'dashboard';

export interface DashboardState {
  dashboardData: IDashboardData | null;
  cityStatisticData: ICityStatisticData | null;
  buyersData: IBuyersData | null;
  categoriesStatisticData: ICategoryStatisticItem[] | null;
  mainMetricsData: IAdminMainMetricsData | null;
  mainMetricsQuery: IAdminMainMetricsQuery;
  mainMetricsPreset: DatePresetKey;
  mainMetricsGroupBy: MainMetricsGroupBy;
  isMainMetricsLoading: boolean;
  isLoading: boolean;
  cityStatisticQuery: TDashboardCityStatisticQuery | null;
  categoriesStatisticQuery: TDashboardCategoriesStatisticQuery | null;
  buyersQuery: TDashboardCityStatisticQuery | null;
  error: IApiError | null;
}

export const initialState: DashboardState = {
  dashboardData: null,
  cityStatisticData: null,
  buyersData: null,
  categoriesStatisticData: null,
  mainMetricsData: null,
  mainMetricsQuery: { group_by: 'day' },
  mainMetricsPreset: DEFAULT_MAIN_METRICS_PRESET,
  mainMetricsGroupBy: 'day',
  isMainMetricsLoading: false,
  isLoading: false,
  cityStatisticQuery: null,
  categoriesStatisticQuery: null,
  buyersQuery: null,
  error: null,
};
